import React, { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import Multiselect from "multiselect-react-dropdown";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function EditProfileBasic({
  user_id,
  user_FullName,
  user_name,
  user_email,
  user_roles,
  updateUserData,
  profilePicture,
}) {
  const { API_URL } = useContext(UrlContext);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [exObject, setExObject] = useState({
    userID: "",
    fullName: "",
    username: "",
    email: "",
    roles: "",
    profilePicture: "",
  });
  const [role, setRole] = useState([
    { name: "Admin", id: "Admin" },
    { name: "IT", id: "IT" },
    { name: "Project Owner", id: "Project Owner" },
    { name: "Project Supporter", id: "Project Supporter" },
    { name: "Tester", id: "Tester" },
    { name: "HR", id: "HR" },
    { name: "Accounting", id: "Accounting" },
    { name: "Demo", id: "Demo" },
  ]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    var userRoleList = user_roles.split(", ");
    var newList = [];
    for (let i = 0; i < Object.keys(userRoleList).length; i++) {
      newList.push({ name: userRoleList[i], id: userRoleList[i] });
    }
    setExObject({
      userID: user_id,
      fullName: user_FullName,
      username: user_name,
      email: user_email,
      roles: newList,
      profilePicture: profilePicture,
    });
  }, [
    user_id,
    user_FullName,
    user_name,
    user_email,
    user_roles,
    profilePicture,
  ]);

  const updateHandler = (e) => {
    e.preventDefault();
    console.log(exObject);
    const url = `${API_URL}update-user-basic`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(exObject),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === "success") {
          console.log("here ince");
          updateUserData(exObject);
          setShowEditPopup(false);
          Swal.fire({
            icon: "success",
            title: "Profile has been updated!",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  return (
    <>
      <i
        className="fa-regular fa-pen-to-square prjdetails-edit-icon"
        title="Edit profile"
        onClick={() => setShowEditPopup(true)}
      />
      {showEditPopup && (
        <div className="prjdetails-conEdit-popup-wrapper">
          <div
            className="tab-pane fade show prjdetails-conEdit-div"
            style={{ height: "450px" }}
          >
            <h4 style={{ marginBottom: "20px" }}>Edit Information</h4>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label className="fontWeight500">Full Name</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ width: "100%" }}
                    value={exObject.fullName}
                    onChange={(e) => {
                      setExObject({ ...exObject, fullName: e.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label className="fontWeight500">User Name</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ width: "100%" }}
                    value={exObject.username}
                    onChange={(e) => {
                      setExObject({ ...exObject, username: e.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label className="fontWeight500">Email</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ width: "100%" }}
                    value={exObject.email}
                    onChange={(e) => {
                      setExObject({ ...exObject, email: e.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label className="fontWeight500">Role</label>
                  <Multiselect
                    options={role}
                    displayValue="name"
                    placeholder="Select Role"
                    closeIcon="cancel"
                    selectedValues={exObject.roles}
                    onSelect={(selectedList, selectedItem) => {
                      setExObject({ ...exObject, roles: selectedList });
                    }}
                    onRemove={(selectedList, removedItem) => {
                      setExObject({ ...exObject, roles: selectedList });
                    }}
                    style={{
                      chips: {
                        background: "#365561",
                      },
                      searchBox: {
                        // border: 'none',
                        width: "100%",
                      },
                      multiselectContainer: {
                        width: "100%",
                      },
                      optionContainer: {
                        marginTop: "-21px",
                      },
                    }}
                  />
                </div>
              </div>
            </div>
            <div>
              <center>
                <button
                  type="button"
                  className="btn btn-light prjdetails-editCancel"
                  onClick={() => setShowEditPopup(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn base-btn"
                  style={{ marginLeft: "6px", width: "5rem" }}
                  onClick={updateHandler}
                  disabled={loading}
                >
                  {loading ? (
                    <img
                      src={LoadingIcon}
                      alt="Loading..."
                      style={{ height: "1.5rem" }}
                    />
                  ) : (
                    "Update"
                  )}
                </button>
              </center>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
